// extracted by mini-css-extract-plugin
module.exports = {"page":"page__3IViT","page-body":"page-body__zf_b5","nav":"nav__UQ7lP","course-list-card":"course-list-card__1Vnhn"};